import BaseCommunicator from "./BaseCommunicator"
import VersionCheck from "../VersionCheck"

class AppCommunicator extends BaseCommunicator {
    constructor(appBridge) {
        super();
        init(appBridge);
        this.getLocale();
    }

    async getLocale() {
        if (this.locale !== undefined) return this.locale;
        try {
            if (this.config === undefined) {
                this.config = await this.getConfig();
            }
            if (this.config.httpHeaders === undefined || this.config.httpHeaders === null || !this.config.httpHeaders.hasOwnProperty("Locale")) {
                this.locale = "en";
            } else {
                this.locale = this.config.httpHeaders["Locale"];
            }
        } catch (e) {
            this.locale = "en";
        }
        return this.locale;
    }

    getConfig() {
        return new Promise((resolve, reject) => {
            broadcast("GetConfig", {}, (error, data) => {
                if (error) return reject(error);
                this.config = data;
                resolve(data);
            });
        });
    }

    getMeinJenaUser() {
        return new Promise((resolve, reject) => {
            broadcast("GetMeinJenaUser", {}, (error, data) => {
                if (error) return reject(error);
                resolve(data);
            });
        })
    }

    openMail() {
        return new Promise((resolve, reject) => {
            broadcast("OpenMail", {}, (error) => {
                if (error) return reject(error);
            });
        });
    }

    setPageTitle(title) {
        return new Promise((resolve, reject) => {
            broadcast("SetPageTitle", {
                pageTitle: title
            }, (error) => {
                if (error) reject(error);
                resolve();
            });
        });
    }

    refreshToken() {
        return new Promise((resolve, reject) => {
            broadcast("RefreshToken", {}, (error, data) => {
                if (error) return reject(error);
                this.authToken = data.authToken;
                resolve(this.authToken);
            });
        });
    }

    reportError(title, message) {
        if (typeof title === "object") {
            message = title.message;
            title = title.title;
        }
        broadcast("ReportError", {
            message: message,
            title: title
        });
    }

    openExternalBrowser(url) {
        broadcast("OpenExternalBrowser", {
            url: url
        });
    }

    openInternalBrowser(url, title, options) {
        broadcast("OpenInternalBrowser", {
            url: url,
            title: title,
            shareButton: options.showShareButton,
            navigationButtons: options.showNavigationButtons,
            crossBackNavigationAndroid: options.showCrossBackNavigationAndroid,
            styleWhite: options.isNavWhite
        });
    }

    async trackPageImpression(pageName) {
        if (this.config === undefined) {
            this.config = await this.getConfig();
        }
        const httpHeaders = this.config.httpHeaders;
        if (httpHeaders.hasOwnProperty("Bundle-Version") && !VersionCheck.check("1.7.2", httpHeaders["Bundle-Version"])) {
            return;
        }
        broadcast("TrackPageImpression", {
            pageName: pageName
        });
    }

    async trackEvent(action, category, label) {
        if (this.config === undefined) {
            this.config = await this.getConfig();
        }
        const httpHeaders = this.config.httpHeaders;
        if (httpHeaders.hasOwnProperty("Bundle-Version") && !VersionCheck.check("1.7.2", httpHeaders["Bundle-Version"])) {
            return;
        }
        broadcast("TrackEvent", {
            action: action,
            category: category,
            label: label + "" || ""
        });
    }
}

function init(appBridge) {
    window.nativeCallback = nativeCallback;
    window.nativeCalls = {};
    window.appBridge = appBridge;
}

/**
 *  Listen to native call without sending
 *  data to the container app
 *  @param {string} name -
 *  @param {function} callback -
 *  @returns {void}
 */
function listen(name, callback) {
    window.nativeCalls[name] = new Call(name, callback, name, null, null, Date.now(), null);
}

/**
 *  Generate uid to identify native callbacks
 *  after call when return from native app
 *  @returns {string} uid
 */
function _generateUid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

/**
 *  Send data to the native app and listen to
 *   the response via callback
 *  @param {string} name -
 *  @param {object} dataDictionary -
 *  @param {function} callback -
 *  @returns {void}
 */
function broadcast(name, dataDictionary, callback) {
    let uid = _generateUid();
    dataDictionary = dataDictionary || {};
    let dataJSON = JSON.stringify(dataDictionary);
    console.log("[Communicator] Broadcast ", uid, name, dataJSON);
    window.nativeCalls[uid] = new Call(uid, callback, name, dataDictionary, null, Date.now(), null);
    switch (window.appBridge) {
        case "Android":
            window.NativeApp.call(uid, name, dataJSON);
            break;
        case "iOS":
            window.nativeAppCall(uid, name, dataJSON);
            break;
        case "webkit":
            window.webkit.messageHandlers.nativeAppCall.postMessage([uid, name, dataJSON]);
            break;
    }
}

/**
 *  Is called by native app.
 *  @param {boolean|string} error -
 *  @param {string} uid -
 *  @param {object} dataDictionary -
 *  @returns {void}
 */
function nativeCallback(error, uid, dataDictionary) {
    if (typeof window.nativeCalls[uid] === "undefined") {
        throw new Error("Callback from native app is not known!", uid, dataDictionary, error, this.nativeCalls);
    }
    if (typeof window.nativeCalls[uid].callback !== "function") {
        throw new Error("Callback object has no function property!", uid, dataDictionary, error, this.nativeCalls);
    }
    window.nativeCalls[uid].callback(error, dataDictionary);
}


/**
 *  Model ...
 *  @param {string} uid -
 *  @param {function} callback -
 *  @param {string} name -
 *  @param {object} requestData -
 *  @param {object} responseData -
 *  @param {number} requestTime -
 *  @param {number} responseTime -
 *  @returns {void}
 */
function Call(uid, callback, name, requestData, responseData, requestTime, responseTime) {
    this.uid = uid;
    this.callback = callback;
    this.name = name;
    this.requestData = requestData;
    this.responseData = responseData;
    this.requestTime = requestTime;
    this.responseTime = responseTime;
}

export {AppCommunicator, broadcast, Call, init}
